enum OrderRowType {
    Fee = 'fee',
    Discount = 'discount',
    Article = 'article',
}

export default OrderRowType;
